<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.00005 1.7998C12.9699 1.7998 16.2 5.0299 16.2 8.9998C16.2 12.9697 12.9699 16.1998 9.00005 16.1998C5.03015 16.1998 1.80005 12.9697 1.80005 8.9998C1.80005 5.0299 5.03015 1.7998 9.00005 1.7998ZM12.709 5.59404C12.3184 5.28627 11.753 5.35291 11.4443 5.7417L7.8311 10.3059L6.5189 8.84775C6.18593 8.47879 5.617 8.44805 5.248 8.78096C4.87903 9.11303 4.8492 9.68195 5.1812 10.0519L7.2062 12.3019C7.3763 12.4918 7.62035 12.5998 7.87505 12.5998H7.90317C8.16859 12.5916 8.41616 12.4666 8.58081 12.2588L12.8558 6.85879C13.1645 6.46909 13.0987 5.90274 12.709 5.59404Z"
            fill="#56B683"
        />
    </svg>
</template>
